var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.wrapperClasses,attrs:{"fx":"","w-100":""}},[_c('i',[_c('i',{style:('width:' + _vm.percent + '%')})]),_c('b',{attrs:{"ml-1":""}},[_vm._v(_vm._s(_vm.percent)+_vm._s(_vm.unit))]),_c('span',{staticClass:"process-time"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }